import React from "react";
import { AnimationUtils } from "three";

import chrono from "chrono-node";
import * as luxon from "luxon";
import { TextareaAutosize } from "../TextareaAutosize";

interface TextAreaProp {
	name?: string;
	initial_value: string;
	updateFunc: (str: string) => void;
	char_limit?: number;
	placeholder?: string;
	rows: number;
	do_not_clear_on_unmount?: boolean;
}

interface TextAreaState {
	value: string;
}

export class TextAreaForm extends React.Component<TextAreaProp, TextAreaState> {
	constructor(props) {
		super(props);

		let value = props.initial_value ? props.initial_value : "";

		this.state = {
			value: value,
		};

		this.handleChange = this.handleChange.bind(this);
	}

	// TODO: Storing redundant state on both this form and its parent, fix??
	handleChange(event) {
		this.setState({ value: event.target.value });
		this.props.updateFunc(event.target.value);
	}

	componentWillUnmount() {
		if (this.props.do_not_clear_on_unmount) return;
		this.props.updateFunc("");
	}

	render() {
		const show_char_count =
			this.props.char_limit &&
			this.state.value.length > this.props.char_limit * 0.85;

		return (
			<div className="field">
				{this.props.name && (
					<label className="label is-size-5">{this.props.name}</label>
				)}
				<div className="control">
					<TextareaAutosize
						className="textarea input"
						placeholder={this.props.placeholder}
						value={this.state.value}
						onChange={this.handleChange}
						maxLength={this.props.char_limit}
						rows={2}
					/>
				</div>
				{show_char_count && (
					<div className="has-text-right">
						<span
							className={
								this.state.value.length ===
								this.props.char_limit
									? "error-text"
									: ""
							}
						>
							{this.state.value.length}/{this.props.char_limit}
						</span>
					</div>
				)}
			</div>
		);
	}
}
